import { render, staticRenderFns } from "./DfSummaryTable.vue?vue&type=template&id=3ed083aa"
import script from "./DfSummaryTable.vue?vue&type=script&lang=js"
export * from "./DfSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./DfSummaryTable.vue?vue&type=style&index=0&id=3ed083aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports